class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".read-more__button");
    this.content = this.querySelector(".read-more__content");
    this.height = getComputedStyle(this.content).height;

    this.init();
    this.addListener();

    window.addEventListener('resize', (e) => {
      this.init();
    });
  }

  init() {
    const computedStyle = window.getComputedStyle(this.content);
    const lineClampValue = computedStyle.getPropertyValue('-webkit-line-clamp');
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const contentHeight = this.content.scrollHeight;
    const textLineCount = contentHeight / lineHeight;

    const hasOverflow = textLineCount > Number(lineClampValue);

    if (hasOverflow) {
      this.trigger.classList.add("read-more__button--active");
    } else {
      this.trigger.classList.remove("read-more__button--active");
    }
  }

  addListener() {
    this.trigger.addEventListener("click", () => this.clickEvent());
  }

  clickEvent() {
    this.classList.contains("read-more--open") ? this.reduceContent() : this.expandContent();
  }

  expandContent() {
    this.classList.add("read-more--open");

    if (this.triggerContent) {
      this.triggerContent.innerHTML = window.expandable_content.read_less;
    }

    const width = getComputedStyle(this.content).width;

    // Set properties to calculate height whilst hiding element
    this.content.style.width = width;
    this.content.style.position = 'absolute';
    this.content.style.visibility = 'hidden';
    this.content.style.height = 'auto';

    const height = getComputedStyle(this.content).height;

    // Reset properties used above to calculate height
    this.content.style.width = null;
    this.content.style.position = null;
    this.content.style.visibility = null;
    this.content.style.height = this.height;

    // Force repaint
    getComputedStyle(this.content).height;
    requestAnimationFrame(() => this.content.style.height = height);

    this.content.addEventListener("transitionend", () => {
      if (this.classList.contains("read-more--open")) this.content.style.height = "auto";
    });
  }

  reduceContent() {
    this.classList.remove("read-more--open");

    if (this.triggerContent) {
      this.triggerContent.innerHTML = window.expandable_content.read_more;
    }
  }
}

customElements.define("read-more", ReadMore);